import { RenderIf } from '@/components/RenderIf';
import { Wrapper, LabelContainer, RequiredAsterisk, DescriptionText } from './styled';
import type { LabelProps } from './types';

const Label = ({ name, htmlFor, required = false, description, className }: LabelProps) => {
    return (
        <Wrapper className={className}>
            <LabelContainer htmlFor={htmlFor}>
                {name}
                <RenderIf isTrue={required}>
                    <RequiredAsterisk>*</RequiredAsterisk>
                </RenderIf>
            </LabelContainer>
            <RenderIf isTrue={Boolean(description)}>
                <DescriptionText>{description}</DescriptionText>
            </RenderIf>
        </Wrapper>
    );
};

export default Label;
